module.exports = __webpack_public_path__ + "img/javaMobile3.a1d82216.jpg";